import $ from 'jquery';
import NavTrigger from '../snippets/NavTrigger';
import Map from '../snippets/Map';
import layout from '../Layout.js';

export default class ContactbarStaticSection {
  constructor(section) {
    this.$el = $(section.el);
    this.$map = $('[data-map]', this.$el);
    this.hasMap = this.$map.length;
    this.apiKey = section.data.api_key;
    this.trigger = section.data.trigger;
    this.postMessage = section.postMessage;

    this.clones = [];
    this.maps = [];
    this.clone();

    if (this.hasMap) {
      this.maps.push(new Map(this.$map[0]));

      if (this.apiKey) {
        if (window.google === undefined) {
          $.getScript(`https://maps.googleapis.com/maps/api/js?key=${this.apiKey}`)
            .done(() => {
              this.maps.forEach(map => map.createMap());
            })
            .fail((status) => {
              console.error(status);
            });
        } else {
          this.maps.forEach(map => map.createMap());
        }
      } else {
        const javascriptApi = 'https://developers.google.com/maps/documentation/javascript/get-api-key';
        const geocodingApi = 'https://developers.google.com/maps/documentation/geocoding/get-api-key';
        const errorMessage = `
          <p>
            To activate your map:
            <ol>
              <li>
                Generate both <a href="${javascriptApi}" target="_blank">JavaScript</a>
                and <a href="${geocodingApi}" target="_blank">Geocoding</a> API keys.
              </li>
              <li>Copy and paste one of them into the theme editor.</li>
              <li>Save your changes to verify the new API key.</li>
            </ol>
          </p>
        `;

        this.maps.forEach(map => map.displayErrorInThemeEditor(errorMessage));
      }
    }

    this.navTrigger = new NavTrigger({
      el: section.el,
      namespace: 'contactbar',
      trigger: this.trigger,
      onShow: () => {
        this.maps.forEach(map => map.resize());
        this.postMessage('nav:close-all', {});
        this.postMessage('nav:close-triggers', { source: this.$el });
        this.postMessage('nav:show-overlay', { source: this.$el });
      },
    });

    this.$mobile = $('.mobilenav-contactbar');
    this.$info = this.$mobile.find('.contactbar-info');
    this.$infoTrigger = this.$mobile.find('[data-contactbar-info-trigger]');
    this.$infoClose = this.$mobile.find('[data-contactbar-info-close]');

    this.events = [
      // Show mobile info panel
      this.$infoTrigger.on('click.contactbar', event => this.$info.revealer()),

      // Hide mobile info panel
      this.$infoClose.on('click.contactbar', event => this.$info.revealer('hide')),
    ];

    // Handle breakpoint changes while editing
    this.layoutHandler = this.onBreakpointChange.bind(this);
    layout.onBreakpointChange(this.layoutHandler);
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.contactbar'));
    this.clones.forEach(clone => clone.$el.empty());
    this.maps.forEach(map => map.unload());

    this.navTrigger.unload();
    layout.offBreakpointChange(this.layoutHandler);
  }

  onSectionSelect() {
    this.isEditing = true;

    if (layout.isBreakpoint('M') || layout.isBreakpoint('L')) {
      this.navTrigger.lock();
    } else {
      this.postMessage('mobilenav:open');
    }
  }

  onSectionDeselect() {
    this.isEditing = false;

    if (layout.isBreakpoint('M') || layout.isBreakpoint('L')) {
      this.navTrigger.unlock();
    } else {
      this.postMessage('mobilenav:close');
    }
  }

  onSectionMessage(name, data) {
    if (name === 'nav:close-triggers' && data.source !== this.$el) {
      this.navTrigger.hide();
    }
    if (name === 'nav:show-overlay') {
      this.navTrigger.showOverlay();
    }
  }

  onBreakpointChange() {
    if (!this.isEditing) return;

    if (layout.isBreakpoint('M') || layout.isBreakpoint('L')) {
      this.navTrigger.lock();
      this.postMessage('mobilenav:close');
    } else {
      this.navTrigger.unlock();
      this.postMessage('mobilenav:open');
    }
  }

  /**
   * Copy the mega nav to other parts of the theme.
   */
  clone() {
    const $source = this.$el.find('[data-contactbar-clone-source]').first();
    if (!$source.length) return;

    const $clone = $source.children().clone();

    // Add contactbar to mobilenav panel
    const $mobileTarget = $('[data-contactbar-mobile-target]');

    if ($mobileTarget.length) {
      $mobileTarget.append($clone);

      this.clones.push({
        $el: $mobileTarget,
      });
    }

    // Add contactbar to contact page
    const $pageTarget = $('[data-contactbar-page-target]');

    if ($pageTarget.length) {
      $pageTarget.append($clone.clone());

      this.clones.push({
        $el: $pageTarget,
      });

      if (this.hasMap) {
        this.maps.push(new Map($('[data-map]', $pageTarget)[0]));
      }
    }
  }
}
